import {
  LOADING_SETTINGS,
  LOAD_SETTINGS,
  FETCH_SETTINGS_REQUEST,
  FETCH_SETTINGS_REQUEST_SUCCESS,
  SETTINGS_SAVE_REQUEST,
  SETTINGS_SAVE_SUCCESS,
} from "../types/settings.types";

export type siteSettingsType = {
  site_title?: string;
  site_logo?: string;
  site_contact_email?: string;
  site_contact_number?: string;
  site_contact_address?: string;
  site_website?: string;
  terms_cond?: string;
  config_name?: string;
  config_value: string;
  enable_visa_type_info: boolean;
  auto_activate_employee: boolean;

  // enable_subscription?: boolean;
};

export type settingsStateType = {
  settings: null | siteSettingsType[];
  setting: null | siteSettingsType;
  loading: false;
  save: false;
};

const initialState: settingsStateType = {
  settings: null,
  setting: null,
  loading: false,
  save: false,
};

export default function settingsReducer(state = initialState, action: any) {
  switch (action.type) {
    case LOAD_SETTINGS:
      return {
        loading: false,
        settings: action.payload,
      };
    case LOADING_SETTINGS:
      return {
        ...state,
        loading: true,
      };
    case FETCH_SETTINGS_REQUEST:
      return {
        ...state,
        setting: null,
        loading: true,
      };
    case FETCH_SETTINGS_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        setting: action.payload,
      };
    case SETTINGS_SAVE_REQUEST:
      return {
        ...state,
        save: false,
      };
    case SETTINGS_SAVE_SUCCESS:
      return {
        ...state,
        save: true,
        setting: null,
      };
    default:
      return state;
  }
}
